import {Component, Input, ViewChild, AfterViewInit} from '@angular/core';

import {UiModalComponent, UiButtonComponent} from "../../shared/ui";

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [UiModalComponent, UiButtonComponent],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent implements AfterViewInit {
  @Input() title = 'Confirm';
  @Input() message = 'Are you sure?';
  @Input() confirmText = 'Yes';
  @Input() cancelText = 'No';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() backdrop: 'static' | true = 'static';

  /** Use 'btn-danger' for destructive actions, else 'btn-primary' */
  @Input() confirmBtnClass: string = 'btn-danger';

  @ViewChild('modal', { static: false }) modal!: UiModalComponent;

  private resolveCallback?: (value: boolean) => void;
  private viewInitialized = false;

  ngAfterViewInit(): void {
    this.viewInitialized = true;
  }

  get confirmVariant(): 'primary' | 'secondary' | 'danger' | 'warning' | 'success' | 'accent' | 'ghost' {
    // Map Bootstrap class names to DaisyUI variants
    if (this.confirmBtnClass.includes('danger')) {
      return 'danger';
    } else if (this.confirmBtnClass.includes('warning')) {
      return 'warning';
    } else if (this.confirmBtnClass.includes('success')) {
      return 'success';
    } else if (this.confirmBtnClass.includes('secondary')) {
      return 'secondary';
    }
    return 'primary';
  }

  open(): Promise<boolean> {
    return new Promise((resolve) => {
      this.resolveCallback = resolve;

      // Wait for ViewChild to be initialized
      const tryOpen = () => {
        if (this.modal && this.viewInitialized) {
          this.modal.open();
        } else {
          setTimeout(tryOpen, 10);
        }
      };

      tryOpen();
    });
  }

  onConfirm() {
    // Resolve first, then close. This avoids any timing issues with modalClosed/onCancel.
    this.resolveCallback?.(true);
    this.resolveCallback = undefined;

    if (this.modal) {
      this.modal.close();
    }
  }

  onCancel() {
    this.resolveCallback?.(false);
    this.resolveCallback = undefined;

    if (this.modal) {
      this.modal.close();
    }
  }
}
